/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core import
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useEdgesState, useNodesState } from 'reactflow';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Radio, Space, Typography } from 'antd';
import { GraphContext } from '../Graphs/FlowGraph';
import { InfoCircleOutlined } from '@ant-design/icons';

// Misc imports
import { NODE_TYPES } from '../../constants/flowGraph';

// Constant declarations
const { Text } = Typography;

const ActivityGraphSettingsForm = () => {
  // React flow store
  const [nodes, setNodes] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const { elements, onElementsUpdated } = useContext(GraphContext);

  const [backButtonEnabled, isBackButtonEnabled] = useState();
  const { t } = useTranslation();

  const getCurrentElements = () => {
    return [...nodes, ...edges];
  };

  // When the conversation graph is fetched anew from the backend
  useEffect(() => {
    setNodes(elements.filter(el => el.data.nodeType === 'node'));
    setEdges(elements.filter(el => el.data.nodeType === 'edge'));
  }, []);

  const applyChanges = () => {
    const node = nodes.filter(node => node.type === NODE_TYPES.MESSAGE || node.type === NODE_TYPES.SELECT);

    const enabledNodes = node.map((node)=> {
      const { data } = node;
      return { [node.id]: { data: { ...data, enableBackAction: backButtonEnabled } } };
    });

    onElementsUpdated(enabledNodes);
  };

  return (
    <Fragment>
      {
        getCurrentElements() ? (
          <Space direction="vertical" align="center" size="middle" className="d-flex">
            <Text className="text-secondary">
              {t('Enable or disable the \'Back\' button across all nodes of this Flow.')}
            </Text>

            <Radio.Group
              className="d-flex flex-column overflow-x-hidden mt-5"
              value={backButtonEnabled}
              onChange={({ target }) => {
                isBackButtonEnabled(target.value);
              }}
              options={[
                {
                  label: 'Enable',
                  value: true,
                  style: { paddingLeft: 3, marginBottom: 10 }
                },
                {
                  label: 'Disable',
                  value: false,
                  style: { paddingLeft: 3, marginBottom: 10 }
                }
              ]}
            >
            </Radio.Group>

            <Button
              type="primary"
              size="large"
              className="mt-5"
              onClick={() => applyChanges()}
            >
              {t('Apply to All Nodes')}
            </Button>

            <Text className="text-secondary">
              <InfoCircleOutlined className="text-secondary mr-2 mt-5" />
              {t('Note that you can still enable/disable the back buttons of individual nodes manually.')}
            </Text>
          </Space>
        ) : null
      }
    </Fragment>
  );
};

export default ActivityGraphSettingsForm;
